<script setup>
import { computed, ref } from 'vue'
import { useStore } from "vuex";
import Content from "@/components/Content/Content.vue";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import {useRouter} from "vue-router";

const store = useStore()
const router = useRouter()

const props = defineProps({
	companyInfo: {
		type: Object,
		default: () => ({})
	}
})

const currentLang = computed(() => store.getters.currentLanguage)
const companyInfo = computed(() => props.companyInfo)

const companyAbout = computed(() => {
	return [
		{
			label: 'companyDesc.FoundingDate',
			value: 2000,
			icon: 'founding-date',
			unit: 'companyDesc.FoundingDateUnit'
		},
		{
			label: 'companyDesc.Employees',
			value: companyInfo.value.company_members,
			icon: 'employee',
			unit: ''
		},
		{
			label: 'companyDesc.Customer',
			value: companyInfo.value.cooperation_clients,
			icon: 'customer',
			unit: ''
		}
	]
})

const toPage = () => {
	router.push('/manufacture')
}

</script>

<template>
	<div class="profile">
		<div class="profile__content">
			<Content
				:title="$t('section.introduce.title')"
				mode="dark"
			>
				<div class="profile__content__box">
					<div class="left">
						<div class="left__header">
							<div class="left__title">
								{{ $t('section.introduce.companyName') }}
							</div>
							<div class="left__more left__more--pc" @click="toPage">
								{{ $t('section.introduce.more') }}
								
								<el-icon size="18" class="left__more__icon">
									<Right />
								</el-icon>
							</div>
						</div>
						
						
						<div class="left__desc">
							<div
								v-html="companyInfo[`brief_introduce_${currentLang}`]"
							/>
<!--							<pre style="width: 100%;white-space: pre-line;margin-bottom: 0;font-family: inherit;">-->
<!--								{{ companyInfo[`brief_introduce_${currentLang}`] }}-->
<!--							</pre>-->
						</div>
						
						<div class="left__more--mobile">
							<div class="left__more" @click="toPage">
								{{ $t('section.introduce.more') }}
								
								<el-icon size="18" class="left__more__icon">
									<Right />
								</el-icon>
							</div>
						</div>
					</div>
					
					<div class="company__info">
						<el-row>
							<el-col
								:xs="8"
								:sm="8"
								:md="8"
								:lg="8"
								:xl="8"
								v-for="(item, index) in companyAbout"
								:key="index"
							>
								<div class="company__info__card">
									<SvgIcon
										:name="item.icon"
										class-name="company__info__card__icon"
									/>
									<div class="company__info__card__right">
										
										<div class="value">
											<span class="value__value">{{ item.value }}</span>
											<span v-if="item.unit" class="unit">{{ $t(item.unit) }}</span>
										</div>
										
										<div class="label">{{ $t(item.label) }}</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</Content>
		</div>
	</div>
</template>

<style scoped lang="less">
.profile {
	width: 100%;
	background: linear-gradient(180deg, #FFFFFF 26%, rgba(255, 255, 255, 0.8) 100%), url("~@/assets/images/index/company.png"), #F5F5F5;
	position: relative;
	
	&__content {
		padding: 70px 0;
		position: relative;
		z-index: 2;
		
		&__box {
			color: #fff;
			
			.left {
				margin-right: 30px;
				
				&__header {
					display: flex;
					justify-content: space-between;
					margin-bottom: 32px;
				}
				
				&__title {
					color: @primary-color;
					font-size: 36px;
					font-weight: bold;
					//margin-bottom: 30px;
				}
				
				&__desc {
					font-size: 18px;
					line-height: 32px;
					color: #303133;
					word-break: break-word;
					word-wrap: break-word;
				}
				
				&__more {
					display: flex;
					align-items: center;
					padding: 16px 40px;
					font-size: 18px;
					font-weight: bold;
					border-radius: 50px;
					cursor: pointer;
					border: 1px solid #303133;
					color: #303133;
					
					&--mobile {
						margin-top: 20px;
						display: none;
					}
					
					&__icon {
						margin-left: 10px;
					}
				}
			}
			
			
			.company__info {
				margin-top: 64px;
				
				&__card {
					display: flex;
					justify-content: center;
					align-items: center;
					
					&__icon {
						width: 72px;
						height: 72px;
					}
					
					&__right {
						margin-left: 24px;
						
						.value {
							display: flex;
							align-items: center;
							
							&__value {
								background: linear-gradient(298deg, #D1170E 3%, #F46760 100%);
								-webkit-background-clip: text;
								-webkit-text-fill-color: transparent;
								background-clip: text;
								text-fill-color: transparent;
								font-size: 48px;
								font-weight: bold;
							}
							
							.unit {
								color: @primary-color;
								font-size: 18px;
								margin-left: 4px;
							}
							
						}
						
						.label {
							font-size: 18px;
							margin-top: 10px;
							color: #303133;
						}
					}
				}
			}
			
		}
	}
}

@media only screen and (max-width: 768px) {
	.profile {
		
		&__content {
			padding: 30px 0;
			&__box {
				
				.left {
					margin-right: 0;
					
					&__header {
						margin-bottom: 20px;
						justify-content: center;
					}
					
					&__title {
						font-size: 24px;
					}
					
					&__desc {
						font-size: 16px;
						line-height: 28px;
					}
					
					&__more {
						border-radius: 30px;
						padding: 12px 30px;
						font-size: 14px;
						
						&__icon {
							margin-left: 5px;
						}
						
					}
					
					&__more--pc {
						display: none;
					}
					
					&__more--mobile {
						display: flex;
						justify-content: center;
					}
				}
				
				.company__info {
					margin-top: 20px;
					
					&__card {
						//margin-bottom: 10px;
						flex-direction: column;
						&__icon {
							width: 48px;
							height: 48px;
						}
						
						&__right {
							margin-left: 0;
							margin-top: 8px;
							
							.value {
								justify-content: center;
								&__value {
									font-size: 24px;
								}
								
								.unit {
									font-size: 14px;
									margin-left: 4px;
								}
								
							}
							
							.label {
								margin-top: 5px;
								font-size: 12px;
								text-align: center;
							}
						}
					}
				}
				
				
			}
		}
	}
}
</style>